const prefix = 'SupplierAddress';

export enum SupplierAddressField {
  SUPPLIER_ID = `${prefix}.supplierId`,
  CITY = `${prefix}.city`,
  STREET = `${prefix}.street`,
  POSTAL_CODE = `${prefix}.postalCode`,
  COUNTRY_CODE = `${prefix}.countryCode`,
}
